<script>
import {BTr} from "bootstrap-vue";

export default {
  extends: BTr
};
</script>